import React, { useState } from "react";
import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import carIcon from "../../images/car-icon.png";
import { Button, FormControl } from "react-bootstrap";
import SeleccionVehiculo from "./SeleccionVehiculo";
import ListadoRepuestos from "./ListadoRepuestos";

const TipoBusquedaRepuestos = () => {
  const [showModal, setShowModal] = useState(false);
  const [showListado, setShowListado] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const handleModeloSelect = (data) => {
    setSelectedData(data);
    setShowModal(false);
    setShowListado(true);
  };

  return (
    <Container>
      {!showListado ? (
        <>
          <div className="Filtro-vehiculo">
            <h3>Encuentre Su Repuesto</h3>
          </div>
          <Row className="mt-3">
            {[
              {
                id: 1,
                title: "Busque su Repuesto",
                buttonText: "Iniciar Búsqueda",
              },
              {
                id: 2,
                title: "Seleccione su vehículo",
                buttonText: "Buscar en el Catálogo",
              },
            ].map(({ id, title, buttonText }) => (
              <Col md={6} className="mb-3" key={id}>
                <div className="Tipo-Busqueda">
                  <Row>
                    <div className="Numero-Busqueda">{id}</div>
                  </Row>
                  <Row>
                    <Col>
                      <div className="Titulo-Busqueda">
                        <h4>{title}</h4>
                      </div>
                    </Col>
                  </Row>
                  {id === 1 ? (
                    <Row>
                      <FormControl
                        placeholder="Número de repuesto"
                        className="my-5"
                      />
                    </Row>
                  ) : (
                    <img
                      src={carIcon}
                      className="Car-Icon my-4 mx-auto d-block"
                      alt="Car Icon"
                    />
                  )}
                  <Row>
                    <Button
                      className="Boton-Busqueda btn btn-primary mx-auto mt-3 py-3 px-5"
                      onClick={id === 2 ? handleShowModal : null}
                    >
                      {buttonText}
                    </Button>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>

          <SeleccionVehiculo
            show={showModal}
            onHide={handleCloseModal}
            selectModelo={handleModeloSelect}
          />

          {selectedData && (
            <div className="Datos-Seleccionados mt-3">
              <h4>Datos Seleccionados:</h4>
              <p>Vehículo: {selectedData.vehicle}</p>
              <p>Año: {selectedData.anio}</p>
            </div>
          )}

          <div className="Filtro-vehiculo mt-0">
            <h3>Garantía de reemplazo de partes y accesorios</h3>
          </div>
          <div className="Tipo-Busqueda mb-3" id="garantia">
            <p>
              Las partes y accesorios genuinos Hyundai suministrados por el
              distribuidor Hyundai autorizado e instalados en cualquier concesionario
              Hyundai, están cubiertos por 1 año o 20.000 km de garantía, lo que
              ocurra primero.
            </p>
          </div>
        </>
      ) : (
        showListado &&
        selectedData && (
          <ListadoRepuestos anio={selectedData.anio} vehicle={selectedData.vehicle} />
        )
      )}
    </Container>
  );
};

export default TipoBusquedaRepuestos;